var { isMobile } = require("./lib/breakpoints");

var { Sidechain } = require("@nprapps/sidechain");
Sidechain.registerGuest();

class IntersectionActivator extends HTMLElement {
  constructor() {
    super();
    if (!"IntersectionObserver" in window) {
      this.observer = false;
      return;
    }
    this.observer = new IntersectionObserver(this.onObservation.bind(this));
    this.observer.observe(this);
  }

  connectedCallback() {
    if (!this.observer) this.classList.add("active");
  }

  onObservation([e]) {
    this.classList.toggle("active", e.isIntersecting);
  }
}

window.customElements.define("intersection-activator", IntersectionActivator);